

export function imagePostFunction(image, src) {
    console.log("----???????----")
    var img = image.getImage();
    if (typeof window.btoa === 'function') {
        var xhr = new XMLHttpRequest();
        //GET ALL THE PARAMETERS OUT OF THE SOURCE URL**
        var dataEntries = src.split("&");
        var url;
        var params = "";
        for (var i = 0; i < dataEntries.length; i++) {
            if (i === 0) {
                url = dataEntries[i];
            } else {
                params = params + "&" + dataEntries[i];
            }
        }
        xhr.open('POST', url, true);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function () {
            if (this.status === 200) {
                var uInt8Array = new Uint8Array(this.response);
                var i = uInt8Array.length;
                var binaryString = new Array(i);
                while (i--) {
                    binaryString[i] = String.fromCharCode(uInt8Array[i]);
                }
                var data = binaryString.join('');
                var type = xhr.getResponseHeader('content-type');
                if (type.indexOf('image') === 0) {
                    img.src = 'data:' + type + ';base64,' + window.btoa(data);
                }
            }
        };
        //SET THE PROPER HEADERS AND FINALLY SEND THE PARAMETERS
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        // xhr.setRequestHeader("Content-length", params.length);
        // xhr.setRequestHeader("Connection", "close");
        xhr.send(params);

    } else {
        img.src = src;
    }
}

